import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { updateCacheByType } from '../../../graphql/GraphQlProvider';
import { ResourceOption } from '../../../graphql/resources.datatypes';
import { gqlResourceOption } from '../getResourceOption.api';

export interface UpdateResourceOptionVars {
  data: {
    id: number,
    resource_id?: number,
    name?: string,
    disabled?: boolean,
    target?: number,
    action_type?: number,
    action_value?: string | null,
    editing_level?: number
    view_level?: number

    conditions?: {
      create?: Array<{
        type: string
        attribute: string
        attribute_type: string
        attribute_value: string
        condition: string
      }>,
      update?: Array<{
        id: number,
        type?: string
        attribute?: string
        attribute_type?: string
        attribute_value?: string
        condition?: string
      }>,
      delete?: number[],
    }
  };
}

interface UpdateResourceOptionData {
  __typename?: string,
  updateResourceOption: ResourceOption
}

export const UPDATE_RESOURCE_OPTION_MUTATION = gql`
    mutation updateResourceOption($data: UpdateResourceOptionInput!) {
        updateResourceOption(data: $data) {
            ${gqlResourceOption}
        }
    }
`;

export const updateResourceOption = () => useMutation<UpdateResourceOptionData, UpdateResourceOptionVars>(
  UPDATE_RESOURCE_OPTION_MUTATION,
  {
    update: updateCacheByType('ResourceOption'),
  }
);

export default updateResourceOption;